<div class="loading-indicator" #loadingContainer>
    <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
</div>
